import { render, staticRenderFns } from "./SelfServiceAutoReply.vue?vue&type=template&id=f1f31f7a&"
import script from "./SelfServiceAutoReply.vue?vue&type=script&lang=js&"
export * from "./SelfServiceAutoReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports